import { type MouseEvent, useCallback, useEffect, useState } from 'react';
import { useRepubContext } from '@cx-web/feature-repub';
import { pollForWindowProperty } from '@cx-web/utils/pollForWindowObject';

import { type Bet } from '~/components/BettingInsights/types';

export const useOCRepubBetslip = ({
  bet,
  onClick,
}: {
  bet: Bet;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}) => {
  const { repubIs } = useRepubContext();
  const [isBetInBetslip, setIsBetInBetslip] = useState(false);

  useEffect(() => {
    if (!repubIs.OC) return;

    const syncBetslipState = async () => {
      await pollForWindowProperty('ocBetslip');
      const betslip = window.ocBetslip;
      betslip.setCallbacks({
        addBet: ({ betId }) => setIsBetInBetslip(betId === bet.betId),
        removeAllBets: () => setIsBetInBetslip(false),
        removeBet: betId => setIsBetInBetslip(betId !== bet.betId),
      });

      setIsBetInBetslip(betslip.isInBetslip(bet.betId));
    };

    syncBetslipState();
  }, [repubIs, bet.betId]);

  const checkBetslipForBet = useCallback(() => {
    return window.ocBetslip.isInBetslip(bet.betId);
  }, [bet.betId]);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      if (window.ocBetslip.isInBetslip(bet.betId)) {
        window.ocBetslip.removeBet({ betId: bet.betId });
      } else {
        window.ocBetslip.addBet(bet);
        window.ocBetslip.toggle();
      }

      onClick?.(e);

      setTimeout(() => {
        setIsBetInBetslip(checkBetslipForBet());
      }, 500);
    },
    [onClick, bet, checkBetslipForBet],
  );

  return {
    isBetInBetslip,
    handleClick,
  };
};
